import { AppStatusBarContextProvider } from '@psl/appComponents/statusBar/provider';
import { createContext, memo, ReactNode, useContext, useMemo } from 'react';
import { AppStatusBar } from './statusBar/AppStatusBar';

export type UserInterfaceStyle = 'light' | 'dark';

export type UserInterfaceIdiom = {
  userInterfaceStyle: UserInterfaceStyle;
};

export const UserInterfaceIdiomContext = createContext<UserInterfaceIdiom>(
  null as any,
);

export const UserInterfaceIdiomProvider = memo(
  ({
    name,
    userInterfaceStyle,
    children,
  }: {
    name: string;
    userInterfaceStyle?: UserInterfaceStyle;
    children?: ReactNode;
  }) => {
    const userInterfaceIdiom = useMemo<UserInterfaceIdiom>(
      () => ({
        userInterfaceStyle: userInterfaceStyle ?? 'light',
      }),
      [userInterfaceStyle],
    );
    return (
      <UserInterfaceIdiomContext.Provider value={userInterfaceIdiom}>
        <AppStatusBarContextProvider name={name}>
          <AppStatusBar />
          {children}
        </AppStatusBarContextProvider>
      </UserInterfaceIdiomContext.Provider>
    );
  },
);

export const useUserInterfaceIdiom = () =>
  useContext(UserInterfaceIdiomContext);

export const useUserInterfaceStyle = () =>
  useUserInterfaceIdiom().userInterfaceStyle;

export const useIsDarkMode = () => useUserInterfaceStyle() === 'dark';
